import { createFileRoute, redirect } from '@tanstack/react-router';

import { getPostAuthLandingRoute } from '@/features/welcome';

export const Route = createFileRoute('/_authenticated/')({
  async loader({ parentMatchPromise }) {
    await parentMatchPromise;
    throw redirect({ to: getPostAuthLandingRoute() as string });
  },
});
